module.exports = __webpack_public_path__ + "static/media/react.5efcf54c.png";